import { connect } from "react-redux";
import {
  selectCurrentPageForActiveCategory,
  setCurrentPage
} from "~/store/ducks/domain/ui/embedded";
import { selectDlsActiveTab } from "~/store/ducks/user/uistate";

import EmbeddedViewer from "./EmbeddedViewer";

function mapStateToProps(state) {
  return {
    currentPage: selectCurrentPageForActiveCategory(state),
    activeTab: selectDlsActiveTab(state)
  };
}

const mapDispatchToProps = {
  setCurrentPage
};

export default connect(mapStateToProps, mapDispatchToProps)(EmbeddedViewer);
